import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploaderComponent } from './Components/uploader/uploader.component';
import { FileUploadModule } from '../primeng/components/fileupload/fileupload';
import { UploaderService } from './Providers/uploader.service';
import { CrmuploaderComponent } from './Components/crmuploader/crmuploader.component';
import { CrmuploaderServiceAttachmentComponent } from './Components/crmserviceattachmentuploader/crmserviceattachmentuploader.component';
import { CrmuploaderServiceAttachmentByFileIDComponent } from './Components/crmserviceattachmentuploaderbyfileId/crmserviceattachmentuploaderbyfileid.component';

@NgModule({
  declarations: [
    UploaderComponent,
    CrmuploaderComponent,
    CrmuploaderServiceAttachmentComponent,
    CrmuploaderServiceAttachmentByFileIDComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FileUploadModule
  ],
  exports: [
    UploaderComponent,
    CrmuploaderComponent,
    CrmuploaderServiceAttachmentComponent,
    CrmuploaderServiceAttachmentByFileIDComponent
  ],
  providers: [
    UploaderService
  ]
})
export class UploaderModule { }
